export default __webpack_public_path__ + "static/media/toHyaluronicAcid.cecb2705.webp";